import React, { ReactNode } from 'react';

interface SettingsCardProps {
  title: string;
  description?: string;
  children: ReactNode;
}

const SettingsCard: React.FC<SettingsCardProps> = ({ title, description, children }) => (
  <div className="pb-4 bg-white rounded-lg shadow-lg py-2">
    <div className="px-2 sm:px-6 lg:px-4 py-4">
      <div className="sm:flex sm:items-center p-2">
        <div className="sm:flex-auto">
          <h1 className="text-lg leading-6 font-medium text-gray-900">{title}</h1>
          <p className="mt-2 text-sm text-gray-700">{description}</p>
        </div>
      </div>
      {children}
    </div>
  </div>
);

export default SettingsCard;

